/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

import { MovieLaurel } from '@usheru-hff/shared/domain';
import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';

@Component({
  selector: 'ush-ui-movie-laurel',
  standalone: true,
  imports: [CommonModule, SharedUtilsImageModule],
  templateUrl: './ui-movie-laurel.component.html',
  styleUrls: ['./ui-movie-laurel.component.scss']
})
export class UiMovieLaurelComponent {
  readonly laurel = input<MovieLaurel>();

  readonly leftLaurelSrc = 'https://cdnstatic.usheru.com/img/misc/left-laurel.png';
  readonly rightLaurelSrc = 'https://cdnstatic.usheru.com/img/misc/right-laurel.png';
}
